//  jQuery
require('./../../../build/node_modules/@components/jquery/dist/jquery.js');

//  Foundation
require('./../../../build/node_modules/@components/foundation-sites/dist/js/foundation.js');

//  Magnific Popup
require('./../../../build/node_modules/@components/magnific-popup/dist/jquery.magnific-popup.js');

//  Flexslider
require('./../../../build/node_modules/@components/flexslider/jquery.flexslider.js');

//  TypedJS
require('./../../../build/node_modules/@components/typed-js/dist/typed.min.js');

//  Waypoints
require('./../../../build/node_modules/@components/waypoints/lib/jquery.waypoints.js');